var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showLoader
    ? _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("b-spinner", {
            staticClass: "my-2",
            attrs: { variant: "primary" },
          }),
        ],
        1
      )
    : _c("div", [
        _setup.errorLoading
          ? _c("div", { staticClass: "error-message w-100 pb-3 text-center" }, [
              _vm._v(_vm._s(_setup.errorLoading)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(_setup.BTable, {
              ref: "placeholdersTable",
              staticClass: "w-100 h-100 items-table",
              attrs: {
                "table-class": "h-100",
                striped: "",
                hover: "",
                items: _setup.uniquePlaceholders,
                "select-mode": "multi",
                fields: _setup.uniquePlaceholdersTableFields,
                responsive: "",
                "show-empty": "",
                "empty-text": "No items",
                selectable: "",
              },
              on: { "row-selected": _setup.onUniquePlaceholderSelected },
              scopedSlots: _vm._u([
                {
                  key: "cell(name)",
                  fn: function (data) {
                    return [
                      _setup.props.podService == "printify"
                        ? _c("div", { staticClass: "text-capitalize" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  data.item.placeholder.position.replace(
                                    "_",
                                    " "
                                  )
                                ) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.props.podService == "printful"
                        ? _c(
                            "div",
                            { staticClass: "align-items-center d-flex h-100" },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(data.item.placeholder.title) +
                                    " (" +
                                    _vm._s(data.item.placeholder.position) +
                                    ")"
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(size)",
                  fn: function (data) {
                    return [
                      _c(_setup.PlaceholderSize, {
                        attrs: {
                          placeholder: _setup.getBiggestPlaceholder(
                            data.item.placeholder
                          ),
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(ratio)",
                  fn: function (data) {
                    return [
                      _c("div", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _setup.formatAspectRatio(data.item.placeholder)
                            ) +
                            "\n                "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(variantsQuantity)",
                  fn: function (data) {
                    return [
                      _c("div", { staticClass: "text-capitalize" }, [
                        _vm._v(_vm._s(data.item.variants.length)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        !_setup.errorLoading
          ? _c("div", { staticClass: "primary-text" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      _setup.showVariantsDetails = !_setup.showVariantsDetails
                    },
                  },
                },
                [_vm._v("Toggle detailed view")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _setup.showVariantsDetails
          ? _c(
              "div",
              _vm._l(_setup.variants, function (providerVariants, providerId) {
                return _c(
                  "div",
                  { key: providerId },
                  [
                    _c(
                      "div",
                      { staticClass: "variant-table-title py-2 px-3" },
                      [
                        _setup.props.podService === "printify"
                          ? _c("b", [
                              _vm._v(
                                '\n                    Select one or more product variants from "' +
                                  _vm._s(
                                    _setup.getPrintProviderName(providerId)
                                  ) +
                                  '"\n                '
                              ),
                            ])
                          : _c("b", [
                              _vm._v(" Select one or more product variants "),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(_setup.VariantSelector, {
                      attrs: {
                        title: "",
                        variants: providerVariants,
                        "show-done-button": false,
                        "row-class-setter": (row) =>
                          _setup.getCssClassesForVariantRow(
                            row,
                            String(providerId)
                          ),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "row-details",
                            fn: function ({ data }) {
                              return [
                                _c("div", { staticClass: "card" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-body" },
                                    [
                                      _c(_setup.MultiSelectTable, {
                                        attrs: {
                                          "show-done-button": false,
                                          fields:
                                            _setup.placeholdersTableFields,
                                          items: _setup.getPlaceholdersForVariant(
                                            String(providerId),
                                            data.id
                                          ),
                                        },
                                        on: {
                                          "selection-finished":
                                            _setup.onPlaceholdersSelectionFinished,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "cell(name)",
                                              fn: function (data) {
                                                return [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        data.item.position.replace(
                                                          "_",
                                                          " "
                                                        )
                                                      ) +
                                                      "\n                                    (" +
                                                      _vm._s(data.item.width) +
                                                      "x" +
                                                      _vm._s(data.item.height) +
                                                      ")\n                                "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value:
                                            _setup.selectedPlaceholdersData[
                                              providerId
                                            ][data.id],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _setup.selectedPlaceholdersData[
                                                providerId
                                              ],
                                              data.id,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "selectedPlaceholdersData[providerId][data.id]",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _setup.selectedVariants[providerId],
                        callback: function ($$v) {
                          _vm.$set(_setup.selectedVariants, providerId, $$v)
                        },
                        expression: "selectedVariants[providerId]",
                      },
                    }),
                    _vm._v(" "),
                    _c("hr"),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.errorSaving
          ? _c("div", { staticClass: "error-message w-100 pb-3 text-center" }, [
              _vm._v(_vm._s(_setup.errorSaving)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _setup.errorLoading
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-danger",
                on: { click: _setup.deleteTemplateProduct },
              },
              [_vm._v("\n        Delete Template Product\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary float-right",
            attrs: { disabled: !_setup.anySelectedPlaceholders },
            on: { click: _setup.onPlaceholdersSelectionFinished },
          },
          [_vm._v("\n        Done\n    ")]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }